export default __webpack_public_path__ + "static/media/filters.f148f7c0.png";